import React, { Fragment } from "react";
import { RotatingLines } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/css/style.css";
import "../components/css/popup.css";

export const xAuth = "M@#weh@##dhASD2627@#2024";
const rootColor = "#858787";

/* ############ ecoz service ########## */
export const service = "ecoz";
export const countryCode = "263";
export const flag = "zw";
export const lang = "en";
export const serviceId = 1;
export const baseUrl = "/zbbApi";
//export const baseUrl = "https://yogamezbox.econet.co.zw/zbbApi";

export const brandImages = [
  "/images/brand_1.png",
  "/images/brand_2.png",
  "/images/brand_3.png",
  "/images/brand_4.png",
  "/images/brand_2.png",
  "/images/brand_5.png",
];

export const footerImages = [
  "/images/footer_3.png",
  "/images/footer_2.png",
  "/images/footer_1.png",
  "/images/footer_4.png",
  "/images/footer_5.png",
];

export const Loader = () => {
  return (
    <div style={{ width: "100px", margin: "auto" }}>
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="60"
        visible={true}
      />
    </div>
  );
};

export const Popup = () => {
  return (
    <div className="popup-container">
      <div className="popup">
        <div style={{ width: "60px", margin: "auto" }}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            animationDuration="0.75"
            width="60"
            visible={true}
          />
        </div>
      </div>
    </div>
  );
};

export const PopupSub = (props) => {
  console.log("sub=" + props.subStatus);
  return (
    <div className="popup-container">
      <div className="popup1">
        {props.subStatus === 2 ? (
          <>
            <div>
              <span>
                Sorry, Your balance is low. Please rechage your <br /> number to
                access service.
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <a className="popupBtnRed" onClick={() => props.redirectTo("")}>
                CLOSE
              </a>
            </div>
          </>
        ) : props.subStatus === 101 ? (
          <>
            <div>
              <h3 className="login-title mb-3 mt-3 text-center">
                You are about to subscribe <br />
                for the YoGamezBox service for <br />
                <span className="span-bold">{props.plan}</span>
                <br /> automatically renewable.
              </h3>
              <h3 className="login-title mb-3 mt-3 text-center">
                Are you sure you want to continue?
              </h3>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a
                  className="popupBtnRed"
                  onClick={() => props.redirectTo("/cancel")}
                >
                  CANCEL
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a className="popupBtn" onClick={() => props.sub()}>
                  CONFIRM
                </a>
              </div>
            </div>
          </>
        ) : props.subStatus === 102 ? (
          <>
            <div>
              <h3
                className={
                  props.message.error
                    ? "login-title-red mb-3 mt-3 text-center"
                    : "login-title mb-3 mt-3 text-center"
                }
              >
                {props.message.message}
              </h3>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <a
                className="popupBtn"
                onClick={() =>
                  props.redirectTo(props.message.error ? "/cancel" : "/main")
                }
              >
                OK
              </a>
            </div>
          </>
        ) : props.subStatus === 103 ? (
          <>
            <div>
              <h3 className="login-title mb-3 mt-3 text-center">
                Are you sure you want to unsubscribe?
              </h3>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a
                  className="popupBtnRed"
                  onClick={() => props.redirectTo("/main")}
                >
                  CANCEL
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a className="popupBtn" onClick={() => props.unsub()}>
                  CONFIRM
                </a>
              </div>
            </div>
          </>
        ) : props.subStatus === 104 ? (
          <>
            <div>
              <h3 className="login-title mb-3 mt-3 text-center">
                Are you sure you want to logout?
              </h3>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a
                  className="popupBtnRed"
                  onClick={() => props.redirectTo("/cancel")}
                >
                  CANCEL
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a
                  className="popupBtn"
                  onClick={() => props.redirectTo("/logout")}
                >
                  CONFIRM
                </a>
              </div>
            </div>
          </>
        ) : props.subStatus === 105 ? (
          <>
            <div>
              <span>
                {" "}
                Your daily play limit is exceeded
                <br /> Please play again Tomorrow.
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <a className="popupBtnRed" onClick={() => props.redirectTo("")}>
                CLOSE
              </a>
            </div>
          </>
        ) : props.subStatus === 207 ? (
          <>
            <div>
              <p className="alert alert-danger">
                You are already logged in on another device. Do you want to
                continue and log out from other sessions?
              </p>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a
                  className="popupBtn"
                  onClick={() => props.redirectTo("/clearSession")}
                >
                  YES
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a
                  className="popupBtnRed"
                  onClick={() => props.redirectTo("/cancel")}
                >
                  NO
                </a>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <span>
                Sorry, YoGamezbox service is available
                <br /> only for paid subscribers.
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a className="popupBtnRed" onClick={() => props.redirectTo("")}>
                  CANCEL
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a
                  className="popupBtn"
                  onClick={() => props.redirectTo("/register")}
                >
                  SUBSCRIBE
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: rootColor,
    fontSize: "13px",
    fontWeight: 300,
    color: rootColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "2px",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    margin: "0 auto",
    minHeight: "30px",
    width: "160px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? rootColor : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "10px",
    marginTop: "5px",
  }),
};

export const Notify = (props) => {
  console.log("props=" + props);
  if (props.message) {
    if (props.type) toast.success(props.message);
    else toast.warning(props.message);
  }

  // inbuilt-notification
  /* toast.success("successful");
    // inbuilt-notification
    toast.info("GeeksForGeeks");
    // inbuilt-notification
    toast.error("Runtime error");
    // default notification
    toast("Hello Geeks");*/

  return <ToastContainer />;
};
